import { render, staticRenderFns } from "./CrmLeadReminderListUi.vue?vue&type=template&id=3d13882c&scoped=true&lang=pug&"
import script from "./CrmLeadReminderListUi.vue?vue&type=script&lang=js&"
export * from "./CrmLeadReminderListUi.vue?vue&type=script&lang=js&"
import style0 from "./CrmLeadReminderListUi.vue?vue&type=style&index=0&id=3d13882c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d13882c",
  null
  
)

export default component.exports